"use strict";

export default class SignIn {
  constructor($signIn) {
    this.$body = $signIn;
    document.documentElement.style.setProperty("--client-color", this.$body.dataset.clientColor);
  }
}
